import { Helmet } from "react-helmet";
import React, { Component } from 'react';
import "../../styles/customers/customers.scss"
import { Button, Badge, FormControl } from 'react-bootstrap';
import CustomerTable from "./customerTable";
import axios from "axios";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import Layout from '../../Layout/layout';
import { setLoadingPage, setErrorMessage } from '../../reducers/actions';
import { connect } from 'react-redux';

class Customers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            customerList: [],
            customerLength: 0,
            customerBoolean: true,
            searchListLength: 0,
            searchBadgeBoolean: false,
        };
        this.sortDirection = '';
        this.sortString = '';
        this.searchText = "";

    }

    async componentDidMount() {
        this.props.setLoadingPageAction(true);

        try {
            const response = await axios.get(`${apiHost}/api/Customer/GetAllCustomers?AllRecords=true&SortDirection=asc&SortString=name`, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token")
                }
            });
            console.log("customerList", response.data)
            this.setState({ customerList: response.data })
            if (this.state.customerBoolean) {

                this.setState({
                    customerLength: response.data.length,
                    customerBoolean: false,
                });

            }
            this.props.setLoadingPageAction(false);

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`)

            }
            this.props.setLoadingPageAction(false);

            console.log(`😱 Axios request failed: ${e}`);
        }
    }

    handleCreateCustomer = () => {
        this.props.history.push("/createCustomer")
    }

    handleDetail = (id) => {
        this.props.history.push(`/customerDetail/${id}`)
    }

    handleSort = (name, order) => {
        this.sortString = name;
        this.sortDirection = order;
        console.log("name", this.sortString, "order", this.sortDirection);
        let query = encodeQueryData(this.setCustomersQueryObject());
        let urlAll = `${apiHost}/api/Customer/GetAllCustomers?${query}`;
        this.getCustomer(urlAll);
    }

    setCustomersQueryObject = () => {
        let data = {};
        data.AllRecords = true;
        data.SearchString = this.searchText;
        data.SortDirection = this.sortDirection;
        data.SortString = this.sortString;
        return data;
    };

    getCustomer = async (url) => {
        try {
            const response = await axios.get(url, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token")
                }
            });
            console.log("customerList", response.data)
            this.setState({ customerList: response.data })
            if (this.state.customerBoolean) {

                this.setState({
                    customerLength: response.data.length,
                    customerBoolean: false,
                });

            }
            this.props.setLoadingPageAction(false);

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`)

            }
            this.props.setLoadingPageAction(false);

            console.log(`😱 Axios request failed: ${e}`);
        }
    }

    handleSearch = async (searchText) => {

        if (searchText == '') {
            this.setState({
                searchBadgeBoolean: false
            })
        } else {
            this.setState({
                searchBadgeBoolean: true
            })
        }
        console.log("searchText", searchText)
        this.searchText = searchText;
        let query = encodeQueryData(this.setCustomersQueryObject());
        let urlAll = `${apiHost}/api/Customer/GetAllCustomers?${query}`;

        this.props.setLoadingPageAction(true);
        try {
            const response = await axios.get(urlAll, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token")
                }
            });
            console.log("customerList", response.data)
            this.setState({
                customerList: response.data,
                searchListLength: response.data.length
            });

            this.props.setLoadingPageAction(false);

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`)

            }
            this.props.setLoadingPageAction(false);

            console.log(`😱 Axios request failed: ${e}`);
        }
    }

    render() {
        const { customerList } = this.state;

        return (
            <React.Fragment>
                <Layout>

                    <Helmet>
                        <title>Customers SPA </title>

                    </Helmet>
                    <div className="contentBody">
                        <div className="contentWrapper">
                            <div style={{ paddingLeft: '10px' }}>

                                <h1 >All Customers</h1>
                                <Button variant="primary" onClick={() => this.handleCreateCustomer()}>+ Create new</Button>
                            </div>
                            <div className="customers">
                                <div className="customer_search">
                                    <FormControl
                                        placeholder="Start typing to filter customers"
                                        aria-label="Start typing to filter customers"
                                        aria-describedby="basic-addon2"
                                        onChange={(e) => this.handleSearch(e.target.value)}
                                    />
                                </div>
                                <h5>Showing {this.state.searchBadgeBoolean && (<span><Badge pill variant="secondary">{this.state.searchListLength}</Badge> out of </span>)}<Badge pill variant="secondary">{this.state.customerLength}</Badge> </h5>

                                <CustomerTable
                                    customers={customerList}
                                    onDetail={this.handleDetail}
                                    sortFunction={this.handleSort}
                                >
                                </CustomerTable>



                            </div>
                            <hr />

                        </div></div>
                </Layout>
            </React.Fragment>


        );
    }

}

const mapStateToProps = (state) => ({

    loading: state.loading

})
const mapDispatchToProps = {
    setLoadingPageAction: setLoadingPage,
    setErrorMessageAction: setErrorMessage


}

export default connect(mapStateToProps, mapDispatchToProps)(Customers);
